import { SensitiveMoney } from "@/components/common/Sensitive";
import {
  resolveSurchargeNoticeOverlay,
  surchargeNoticeAmountChanged,
  surchargeNoticeOverlayByCode,
} from "@/lib/surchargeNoticeDisplay";
import { effectiveSurchargeAmount, normSurchargeBasis } from "@/lib/surchargeDisplay";

import { SurchargeNoticeMark } from "./SurchargeNoticeMark";

interface SurchargeAmountWithNoticeProps {
  code: string;
  amount: number;
  currency: string;
  basis?: string | null;
  equipmentSize?: string | null;
  overlayByCode: ReturnType<typeof surchargeNoticeOverlayByCode>;
}

export function SurchargeAmountWithNotice({
  code,
  amount,
  currency,
  basis,
  equipmentSize,
  overlayByCode,
}: SurchargeAmountWithNoticeProps) {
  const overlay = resolveSurchargeNoticeOverlay(overlayByCode, code, currency);
  const isTeu = normSurchargeBasis(basis) === "teu";
  const displayAmount = overlay
    ? overlay.adjusted_amount
    : effectiveSurchargeAmount({ basis, amount }, equipmentSize);
  const changed =
    overlay != null && surchargeNoticeAmountChanged(overlay);
  const showBasisSuffix =
    normSurchargeBasis(basis) !== "container" && !isTeu && !overlay;

  return (
    <span className="inline-flex items-center gap-1.5">
      {overlay ? <SurchargeNoticeMark overlay={overlay} /> : null}
      <span className="inline-flex items-baseline gap-1 tabular-nums">
        {changed && overlay ? (
          <SensitiveMoney
            amount={overlay.original_amount}
            className="text-muted-foreground line-through"
          />
        ) : null}
        <SensitiveMoney amount={displayAmount} />
        {showBasisSuffix && basis ? (
          <span className="text-xs text-muted-foreground">/{basis}</span>
        ) : null}
      </span>
    </span>
  );
}
